import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=4407e032&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"
import style0 from "./photo.vue?vue&type=style&index=0&id=4407e032&prod&lang=css&"
import style1 from "./photo.vue?vue&type=style&index=1&id=4407e032&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407e032",
  null
  
)

export default component.exports